import React from 'react'

const Header = () => {
  return (
    <div className='absolute bg-gradient-to-b from-black w-full'>
    <img className='lg:w-56 md:w-36 lg:ml-12 z-10 lg:mt-4 relative' src="https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png" alt="logo" />
    </div>
  )
}

export default Header